// src/pages/Account.js
import { useState } from 'react'
import { useAuth } from '../hooks/useAuth'
import Layout from '../components/common/Layout'
import Button from '../components/common/Button'
import { Switch } from '@headlessui/react'
import {supabase} from "../utils/supabase";

export default function Account() {
  const { user, signOut } = useAuth()
  const [notifications, setNotifications] = useState({
    weeklyDigest: false,
    billing: true,
    productNews: false
  })
  const [showDeleteConfirm, setShowDeleteConfirm] = useState(false)
  const [deleteConfirmText, setDeleteConfirmText] = useState('')

  const [isDeleting, setIsDeleting] = useState(false)

  const handleDeleteAccount = async () => {
    if (deleteConfirmText !== user?.user_metadata?.user_name) {
      return
    }

    const { data: { session } } = await supabase.auth.getSession();

    if (!session) {
      throw new Error('User not authenticated');
    }

    setIsDeleting(true)

    try {
      // 调用删除账户的API
      const response = await fetch('https://api.echoguard.app/api/delete-account', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          'Authorization': `Bearer ${session.access_token}`
        },
        body: JSON.stringify({})
      })

      if (!response.ok) {
        console.error(response.text())
        throw new Error(response.json().message || 'Failed to delete account')
      }

      // 删除成功后登出
      await signOut()

      // 可选：重定向到首页或显示确认消息
      window.location.href = '/'

    } catch (error) {
      console.error('Error deleting account:', error)
      alert('Failed to delete account. Please try again.')
    } finally {
      setIsDeleting(false)
      setShowDeleteConfirm(false)
      setDeleteConfirmText('')
    }
  }
  
  return (
    <Layout>
      <div className="space-y-8">
        <div className="border-b border-gray-200 pb-4">
          <h1 className="text-2xl font-bold text-gray-900">Account Settings</h1>
          <p className="mt-1 text-sm text-gray-600">
            Manage your account preferences and settings
          </p>
        </div>
        
        {/* Profile Section */}
        <div className="bg-white border border-gray-200 rounded-lg p-6">
          <h2 className="text-lg font-medium text-gray-900 mb-4">Profile</h2>
          
          <div className="flex items-center space-x-4">
            <img
              className="h-16 w-16 rounded-full"
              src={user?.user_metadata?.avatar_url || `https://github.com/${user?.user_metadata?.user_name}.png`}
              alt=""
            />
            <div>
              <p className="text-base font-medium text-gray-900">
                Logged in as @{user?.user_metadata?.user_name}
              </p>
              <p className="text-sm text-gray-600">
                {user?.email}
              </p>
              <p className="text-xs text-gray-500 mt-1">
                Authentication via GitHub OAuth - no password management needed
              </p>
            </div>
          </div>
        </div>
        
        {/*/!* Notifications Section *!/*/}
        {/*<div className="bg-white border border-gray-200 rounded-lg p-6">*/}
        {/*  <h2 className="text-lg font-medium text-gray-900 mb-4">Notifications</h2>*/}
        {/*  <p className="text-sm text-gray-600 mb-6">*/}
        {/*    Choose which emails you'd like to receive from EchoGuard*/}
        {/*  </p>*/}
        {/*  */}
        {/*  <div className="space-y-4">*/}
        {/*    <div className="flex items-center justify-between">*/}
        {/*      <div>*/}
        {/*        <p className="text-sm font-medium text-gray-900">Weekly Activity Digest</p>*/}
        {/*        <p className="text-xs text-gray-600">*/}
        {/*          Receive a weekly summary of how much time EchoGuard saved you*/}
        {/*        </p>*/}
        {/*      </div>*/}
        {/*      <Switch*/}
        {/*        checked={notifications.weeklyDigest}*/}
        {/*        onChange={(checked) => setNotifications(prev => ({ ...prev, weeklyDigest: checked }))}*/}
        {/*        className={`${*/}
        {/*          notifications.weeklyDigest ? 'bg-blue-600' : 'bg-gray-200'*/}
        {/*        } relative inline-flex h-6 w-11 items-center rounded-full transition-colors focus:outline-none focus:ring-2 focus:ring-blue-500 focus:ring-offset-2`}*/}
        {/*      >*/}
        {/*        <span*/}
        {/*          className={`${*/}
        {/*            notifications.weeklyDigest ? 'translate-x-6' : 'translate-x-1'*/}
        {/*          } inline-block h-4 w-4 transform rounded-full bg-white transition-transform`}*/}
        {/*        />*/}
        {/*      </Switch>*/}
        {/*    </div>*/}
        {/*    */}
        {/*    <div className="flex items-center justify-between">*/}
        {/*      <div>*/}
        {/*        <p className="text-sm font-medium text-gray-900">Billing & Subscription Updates</p>*/}
        {/*        <p className="text-xs text-gray-600">*/}
        {/*          Important notifications about your subscriptions and payments*/}
        {/*        </p>*/}
        {/*      </div>*/}
        {/*      <Switch*/}
        {/*        checked={notifications.billing}*/}
        {/*        onChange={(checked) => setNotifications(prev => ({ ...prev, billing: checked }))}*/}
        {/*        className={`${*/}
        {/*          notifications.billing ? 'bg-blue-600' : 'bg-gray-200'*/}
        {/*        } relative inline-flex h-6 w-11 items-center rounded-full transition-colors focus:outline-none focus:ring-2 focus:ring-blue-500 focus:ring-offset-2`}*/}
        {/*      >*/}
        {/*        <span*/}
        {/*          className={`${*/}
        {/*            notifications.billing ? 'translate-x-6' : 'translate-x-1'*/}
        {/*          } inline-block h-4 w-4 transform rounded-full bg-white transition-transform`}*/}
        {/*        />*/}
        {/*      </Switch>*/}
        {/*    </div>*/}
        {/*    */}
        {/*    <div className="flex items-center justify-between">*/}
        {/*      <div>*/}
        {/*        <p className="text-sm font-medium text-gray-900">Product News & Feature Updates</p>*/}
        {/*        <p className="text-xs text-gray-600">*/}
        {/*          Stay informed about new features and improvements*/}
        {/*        </p>*/}
        {/*      </div>*/}
        {/*      <Switch*/}
        {/*        checked={notifications.productNews}*/}
        {/*        onChange={(checked) => setNotifications(prev => ({ ...prev, productNews: checked }))}*/}
        {/*        className={`${*/}
        {/*          notifications.productNews ? 'bg-blue-600' : 'bg-gray-200'*/}
        {/*        } relative inline-flex h-6 w-11 items-center rounded-full transition-colors focus:outline-none focus:ring-2 focus:ring-blue-500 focus:ring-offset-2`}*/}
        {/*      >*/}
        {/*        <span*/}
        {/*          className={`${*/}
        {/*            notifications.productNews ? 'translate-x-6' : 'translate-x-1'*/}
        {/*          } inline-block h-4 w-4 transform rounded-full bg-white transition-transform`}*/}
        {/*        />*/}
        {/*      </Switch>*/}
        {/*    </div>*/}
        {/*  </div>*/}
        {/*</div>*/}
        
        {/* Danger Zone */}
        <div className="bg-white border border-red-200 rounded-lg p-6">
          <h2 className="text-lg font-medium text-red-900 mb-4">Danger Zone</h2>
          <p className="text-sm text-red-700 mb-6">
            These actions are permanent and cannot be undone
          </p>
          
          <Button
            variant="danger"
            onClick={() => setShowDeleteConfirm(true)}
          >
            Delete My EchoGuard Account
          </Button>
          
          {showDeleteConfirm && (
            <div className="mt-6 p-4 bg-red-50 border border-red-200 rounded-lg">
              <h3 className="text-base font-medium text-red-900 mb-3">
                Confirm Account Deletion
              </h3>
              
              <p className="text-sm text-red-800 mb-4">
                This action will permanently delete your EchoGuard account and all configuration data, 
                and cancel all paid subscriptions. This action cannot be undone. Please note that 
                you will still need to manually uninstall the EchoGuard app on GitHub.
              </p>
              
              <div className="space-y-4">
                <div>
                  <label className="block text-sm font-medium text-red-900 mb-2">
                    Type your GitHub username "{user?.user_metadata?.user_name}" to confirm:
                  </label>
                  <input
                    type="text"
                    value={deleteConfirmText}
                    onChange={(e) => setDeleteConfirmText(e.target.value)}
                    className="w-full rounded-md border-red-300 shadow-sm focus:border-red-500 focus:ring-red-500 sm:text-sm"
                    placeholder={user?.user_metadata?.user_name}
                  />
                </div>
                
                <div className="flex space-x-3">
                  <Button
                      variant="danger"
                      onClick={handleDeleteAccount}
                      disabled={deleteConfirmText !== user?.user_metadata?.user_name || isDeleting}
                  >
                    {isDeleting ? 'Deleting...' : 'Delete Account Permanently'}
                  </Button>
                  <Button
                    variant="secondary"
                    onClick={() => {
                      setShowDeleteConfirm(false)
                      setDeleteConfirmText('')
                    }}
                  >
                    Cancel
                  </Button>
                </div>
              </div>
            </div>
          )}
        </div>
      </div>
    </Layout>
  )
}

